import React from 'react';

interface IInlineFormRowProps {
  label: string;
  controlWidthClass?: string;
  children: React.ReactNode;
}

const DEFAULT_CONTROL_WIDTH_CLASS = 'w-[120px]';

export const InlineFormRow: React.FC<IInlineFormRowProps> = ({
  label,
  controlWidthClass = DEFAULT_CONTROL_WIDTH_CLASS,
  children
}): React.ReactElement => {
  return (
    <div className="flex items-center justify-between mt-2">
      <span className="text-sm text-black whitespace-nowrap">{label}</span>
      <div className={controlWidthClass}>{children}</div>
    </div>
  );
};
